module.exports = __webpack_public_path__ + "img/Ident-Process-3.c92c306d.png";